import { getExpDate } from "./../utils/calendar";
import { PaymentType } from "./../enums/payment";
import { BaseService } from "./BaseService";
const config = require("../../config.js");
import { CognitoUser } from "amazon-cognito-identity-js";
import { VantivCardTypes } from "../../types/vantiv";
import { nanoid } from "nanoid/non-secure";

interface AddPaymentMethodBody extends Record<string, any> {
  reservationId: string;
  zip: string;
  type: keyof typeof VantivCardTypes;
  cardholder: string;
  expDate: string;
  paypageRegistrationId: string;
  cardNumber: number;
  allowCof: boolean;
  paymentSourceType: string;
  paymentScheduleType: string;
  paymentType: keyof typeof PaymentType;
  streetAddress?: string;
  state?: string;
  streetAddress2?: string;
  city?: string;
  bankAccountNumber?: string;
  paymentRoutingNumber?: string;
  yodleeAccountId?: string;
}

export class PaymentSourceService extends BaseService {
  constructor(
    public cognitoUser: CognitoUser,
    public dispatch = (any: any) => {},
    public url = config.domusoApiService
  ) {
    super(url, cognitoUser, dispatch);
  }

  async addPaymentMethodBA(body: AddPaymentMethodBody, signal?: AbortSignal) {
    const {
      type,
      paymentScheduleType = "ONE_SHOT",
      cardNumber,
      streetAddress2,
      allowCof = false,
      paymentType = "RENT",
      reservationId,
      nickname,
      ...requiredAttributes
    } = body;
    const url = `v1/my/payment_source`;

    const finalBody = {
      request_id: nanoid(36),
      reservation_id: `${reservationId}`,
      payment_source_type: "BANK_ACCOUNT",
      bank_account_type: body.bankAccountType || body.accountType,
      bank_account_number: body.bankAccountNumber,
      account_number: body.accountNumber,
      payment_routing_number: body.routingNumber,
      payment_type: paymentType,
      cardholder: body.cardholder,
      allow_cof: body.allowCof,
      payment_schedule_type: paymentScheduleType,
      yodlee_account_id: body.yodleeAccountId,
      nickname: nickname,
    };
    await this.logger.log({ finalBody, url });
    return this.makePostRequest(url, finalBody, true, true, signal);
  }
}
